import React, { useCallback, useState } from "react";
import ErrorNotification from "src/components/ErrorNotification";
import GenericMasonry from "src/components/GenericMasonry";
import {
  useSearchOrgImages,
  useDeleteOrgImagesById,
  useUploadOrgImages,
} from "src/hooks/orgImages";

const normalizeItem = (item) => ({
  id: item.id,
  src: item.url,
  alt: item.name,
  width: item.width,
  height: item.height,
});

const ImageLibrary = () => {
  const { searchOrgImages } = useSearchOrgImages();
  const { uploadOrgImages } = useUploadOrgImages();
  const { deleteOrgImagesById } = useDeleteOrgImagesById();
  const [uploadError, setUploadError] = useState(null);

  const onUploadImages = useCallback(
    async (filesToUpload) => {
      const { images, error } = await uploadOrgImages(filesToUpload);

      if (error) {
        setUploadError(error);
        return [];
      }

      return images.map(normalizeItem);
    },
    [uploadOrgImages, setUploadError]
  );

  const onDeleteImage = useCallback(
    async (imageId) => {
      try {
        await deleteOrgImagesById([imageId]);
      } catch (error) {
        setUploadError(error);
      }
    },
    [deleteOrgImagesById]
  );

  const fetchItems = useCallback(
    async (page, limit, searchTerm) => {
      try {
        const result = await searchOrgImages({
          searchTerm,
          offset: page * limit,
          limit,
          generateUrls: true,
        });

        return {
          data: result.images.map(normalizeItem),
          error: null,
          hasMore: result.hasMore,
        };
      } catch (error) {
        return {
          data: [],
          error,
          hasMore: false,
        };
      }
    },
    [searchOrgImages]
  );

  return (
    <>
      <GenericMasonry
        fetchItems={fetchItems}
        onUpload={onUploadImages}
        onDeleteImage={onDeleteImage}
        title="Uploaded images"
      />
      {uploadError && (
        <ErrorNotification
          error={uploadError}
          onDismiss={() => setUploadError(null)}
        />
      )}
    </>
  );
};

export default ImageLibrary;
